module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h11"
  }, [_vm._v("A"), _c('span', {
    staticClass: "th13"
  }, [_vm._v("CKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t13"
  }, [_vm._v("There are always people to thank, people who have helped me, supported me, and more. These people are the unsung heroes in my life, and this is my shout-out to them and my eternal thank-you to all of them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("In gratitude to Cate Ashwood, one of the best besties a person could ask for; Meredith Shayne, Marina Pycroft, Sue Cavanagh-Lang, Claire Clarke, Tracy Bailey, Jazz Pycroft, Alex Dewar, Erin, Michelle Wauchope; Shane Bevin, Chris Spud, Hermann Lauss, Harry Butler, Terry Rowe, FAL, Tien, and Zathyn Priest. For my family: Mum, Dad, Dr. Ian, Christy and Shandi, my brother John.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("And my eternal gratitude to Dreamspinner Press, including Elizabeth North, Lynn West, Erika Orrick, Anne Cain, and everyone else at DSP.")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_vm._v("Thank you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47dfb4e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/007.vue
// module id = 72
// module chunks = 0